import axios from "axios";

export default class Compesation {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
    // this.API_LINK = 'http://localhost:8016';
  }
  
  async saveCompensationsNoEconomic(data) {
    try {
        const response = await axios({
          method: "post",
          url: `${this.API_LINK}/compensations/no-economic/benefits`,
          data:data
        });
        return response;
      } catch (error) {
        throw error;
      }
    
  }
  async saveCompensationsSubsidiary(data) {
    try {
        const response = await axios({
          method: "post",
          url: `${this.API_LINK}/compensations/subsidiary/benefits`,
          data:data
        });
        return response;
      } catch (error) {
        throw error;
      }
    
  }

  async getCompensationsNoEconomic() {
    try {
        const response = await axios({
          method: "get",
          url: `${this.API_LINK}/compensations/no-economic/benefits?limit=25&offset=0`,
        });
        return response;
      } catch (error) {
        throw error;
      }
    
  }
  async getCompensationsSubsidiary() {
    try {
        const response = await axios({
          method: "get",
          url: `${this.API_LINK}/compensations/subsidiary/benefits?limit=25&offset=0`,
        });
        return response;
      } catch (error) {
        throw error;
      }
    
  }

  

}


